export default (params) => ({
  trigger: {
    name: 'product_collection.click_information_icon',
    params: params,
  },
  config: {
    schema: {
      property_name: {
        type: 'string',
      },
      sub_feature: {
        enum: [
          'multi_discriminant_selector',
          'drop_down_panel',
          'direct_collection',
        ],
      },
    },
    event: {
      name: 'interact_with_property',
      params: {
        property_value: null,
        method: 'explanation',
      },
    },
    nonInt: false,
  },
});
